export default __webpack_public_path__ + "assets/6e94ee.png";